import { render, staticRenderFns } from "./ProgramDetailsOverviewCard.vue?vue&type=template&id=a103a4e6&scoped=true"
import script from "./ProgramDetailsOverviewCard.vue?vue&type=script&lang=js"
export * from "./ProgramDetailsOverviewCard.vue?vue&type=script&lang=js"
import style0 from "./ProgramDetailsOverviewCard.vue?vue&type=style&index=0&id=a103a4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a103a4e6",
  null
  
)

export default component.exports